import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "react-phone-number-input/style.css";
import "./index.css";
import App from "./Modules/App";
import reportWebVitals from "./reportWebVitals";
import theme from "src/Theme";
import "react-multi-carousel/lib/styles.css";
import Fonts from "./static/Font";
import "rc-slider/assets/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      gcTime: 5000,
    },
    mutations: {
      throwOnError: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ChakraProvider
      resetCSS
      theme={theme}
      toastOptions={{ defaultOptions: { position: "top-right" } }}
    >
      <QueryClientProvider client={queryClient}>
        <Fonts />
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ChakraProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
